/** SA-1331: the one sentence a held-back task action gives for its reason. */
export function fillFirst(labels: string[]): string {
  return `Fill ${labels.join(', ')} first.`
}

/** The task views' draft button (SA-1333). */
export const SAVE_DRAFT = 'Save draft'
